import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { UPDATE_PASSWORD_RESET } from '../../../constants/actionTypes'
import { updatePassword } from '../../../actions/authAction'
import { Header,Sidebar } from '../Layout';
import * as Yup from "yup";
// import ViewProfile from './ViewProfile';
import { useFormik } from 'formik';

const ChangePassword = () => {

    const dispatch = useDispatch()

    // const [password, setPassword] = useState({
    //     oldPassword: '',
    //     newPassword: '',
    //     confirmNewPassword: ''
    // })

    const { message } = useSelector(state => state.updatePassword)
    const { user } = useSelector(state => state.auth)

    useEffect(() => {
        if (message) {
            toast.success(message)
        }

    }, [message])

    useEffect(() => {
        return () => { dispatch({ type: UPDATE_PASSWORD_RESET }) }
    }, [dispatch])


    const formik = useFormik({
		initialValues: {
			oldPassword: '',
			newPassword: '',
			passwordConfirmation: '',
		},
		validationSchema: Yup.object({
            oldPassword: Yup.string().required("Old password is required"),
            newPassword: Yup.string()
			.min(6, 'Must be 6 characters or more')
			.max(12, 'Must be 12 characters or less')
			.required('Please Enter your password')
			.matches(
				/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{6,12}$/,
				"Must contain 6 characters, one uppercase, one lowercase, one number and one special case character"
			),
            passwordConfirmation: Yup.string()
                .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
		}),
		onSubmit: (value, { resetForm }) => {
			 const password = {
                 oldPassword: value.oldPassword,
                 newPassword: value.newPassword,
             };
            dispatch({ type: UPDATE_PASSWORD_RESET })
            dispatch(updatePassword(password))
			resetForm();
		},
	});
    return (
        <>
        <Header/>
        <Sidebar/>
        <div id="main-content">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h2>Change password</h2>
                    </div>            
                    <div className="col-md-6 col-sm-12 text-right">
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                            <li className="breadcrumb-item active">Change password</li>
                        </ul>
                    </div>
                </div>
            </div>
        <div className="container-fluid">           

            <div className="row clearfix">
              {/* Profile View */}
                {/* <ViewProfile /> */}
                <div className="col-lg-2 col-md-12">
                </div>
                {/* Update Profile */}
                <div className="col-lg-8 col-md-12">
                    <div className="card">
                        <div className="header bline">
                            <h2>Account Data</h2>
                        </div>
                        <div className="body">
                            <div className="row clearfix">
                                <div className="col-lg-12 col-md-12">                                            
                                    <div className="form-group">                                                
                                        <input type="text" className="form-control" defaultValue={user?.email} disabled placeholder="Email" />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                <form onSubmit={formik.handleSubmit}>
                                    <h6>Change Password</h6>
                                    <div className="form-group">
                                        <input type="password" {...formik.getFieldProps('oldPassword')} className="form-control" placeholder="Current Password" />
                                        {formik.touched.oldPassword && formik.errors.oldPassword ? (
                                            <div className="text-danger pt-2">{formik.errors.oldPassword}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group">
                                        <input type="password" {...formik.getFieldProps('newPassword')} className="form-control" placeholder="New Password" />
                                        {formik.touched.newPassword && formik.errors.newPassword ? (
                                            <div className="text-danger pt-2">{formik.errors.newPassword}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group">
                                        <input type="password" {...formik.getFieldProps('passwordConfirmation')}className="form-control" placeholder="Confirm New Password" />
                                        {formik.touched.passwordConfirmation && formik.errors.passwordConfirmation ? (
                                            <div className="text-danger pt-2">{formik.errors.passwordConfirmation}</div>
                                        ) : null}
                                    </div>
                                    <button type="submit" className="btn button">Update</button>
                                </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        </>
    );
}

export default ChangePassword
